import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
  MatDialog,
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NotifySlUsersBy } from '../../constants/KRollConstants';
import { KRollService } from '../../services/api-services/kroll.service';
import { ShippingService } from '../../services/api-services/shipping.service';
import { FormService } from '../../services/form.service';
import { HelperService } from '../../services/helper.service';
import { arrayMinLengthByKey } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';
import { Validators, AbstractControl } from '@angular/forms';
import { PreAssessmentService } from 'src/app/core/services/api-services/pre-assessments.service';
import { UserService } from '../../services/api-services/user.service';
import { BookAppointementService } from '../../services/api-services/book-appointment.service';
import { AddAppointmentPlatformComponent } from 'src/app/pages/create-user-appointment/add-appointment-platform/add-appointment-platform.component';
import { AddPatientGroupModalComponent } from 'src/app/pages/create-user-appointment/add-patient-group-modal/add-patient-group-modal.component';
import * as moment from 'moment';
enum NotifyType {
  sms = 'sms',
  message = 'message',
  do_not = 'do_not',
}
@Component({
  selector: 'app-doctor-appointment-status',
  templateUrl: './doctor-appointment-status.component.html',
  styleUrls: ['./doctor-appointment-status.component.scss'],
})
export class DoctorAppointmentStatusComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  NotifyType = NotifyType;
  tenant: any = localStorage.getItem('tenant');
  payload: { NotifyUsers: boolean; NotifySlUsersBy: Array<number> } = {
    NotifyUsers: true,
    NotifySlUsersBy: [],
  };
  preSelectedStatuses = [
    'cancelled',
    'completed',
    'pending',
    'unavailable',
    'scheduled',
  ];
  scheduledStatus = ['scheduled'];
  appointmentsPlateform: any[] = [];
  patientGroupList: any[] = [];
  userAppointmentMessage!: string;
  selectedStatus: any;
  isScheduledStatus: boolean = false;
  currentDate: string | undefined;
  hideForQc = false;
  formDate = '';
  formTime: string = '';
  isVideoSelected!: boolean;

  constructor(
    public dialogRef: MatDialogRef<DoctorAppointmentStatusComponent>,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public toast: ToastrService,
    public shippingService: ShippingService,
    public formService: FormService,
    public krollService: KRollService,
    public toastr: ToastrService,
    public userService: UserService,
    public preAssessmentService: PreAssessmentService,
    public validationMessagesService: ValidationMessagesService,
    public helperService: HelperService,
    private appointmentService: BookAppointementService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any
  ) {

    const lastSlotDatetime = this.props?.item?.appointment_datetime;
    if (lastSlotDatetime) {
      const [date, time] = lastSlotDatetime.split(' ');
      this.formDate = date;
      this.formTime = time;
    } else {
      console.log("No last_slot_datetime provided.");
    }

    if (this.tenant == 'qc') {
      this.hideForQc = true;
    }
  }

  ngOnInit(): void {
    this.selectedStatus = this.props.item.status;
    this.isScheduledStatus = this.scheduledStatus.includes(this.selectedStatus);
    const speakType = this.props?.item?.speak_a_practitioner;
    const status = this.props?.item?.status;
    this.isVideoSelected = speakType == 'video' && status == 'scheduled';
    this.initializeForm();
    this.updateFormWithTime();
  }

  onCheckChange(event: MatCheckboxChange) {
    const customMessageControl = this.form.get('custom_message');
    if (customMessageControl) {
      if (event.checked) {
        this.addNotifyControl();
      } else {
        // Set custom_message control value to false
        customMessageControl.setValue(false);
        this.form.removeControl('NotifyUsersBy');
      }
    }
  }
  onCheckMessage(event: MatCheckboxChange) {
    const validators = this.getConditionalValidators();
    this.form.controls['message'].setValidators(validators);
    this.form.controls['message'].updateValueAndValidity();
  }

  initializeForm() {
    let { NotifyUsers } = this.payload;
    const isCustomMessageSelected = false;
    this.form = this.fb.group({
      NotifyUsers: new FormControl(NotifyUsers),
      custom_message: new FormControl(isCustomMessageSelected),
      practitioner_name: new FormControl(this.props?.item?.doctor_info?.practitioner_name, this.isScheduledStatus ? Validators.required : []),
      appointment_datetime: new FormControl(this.formDate, this.isScheduledStatus ? [this.validateFutureDate, Validators.required] : []),
      PreferredTime: [null, this.isScheduledStatus ? Validators.required : []],
      appointment_platform_id: new FormControl('', this.isScheduledStatus ? Validators.required : []),
      patient_group_id: new FormControl(''),
      appointment_video_link: new FormControl(this.props?.item?.appointment_video_link),
      message: new FormControl('', this.getConditionalValidators()),
      NotifyUsersBy: this.fb.array([]),
    });

    this.addNotifyControl();
    this.getAppointmentBasicData();
  }

  updateFormWithTime(): void {
    const lastSlotDatetime = this.props?.item?.appointment_datetime;
    if (lastSlotDatetime) {
      const [date, time] = lastSlotDatetime.split(' ');
      this.formTime = time;
      const timeParts = this.formTime.split(':');
      const timeDate = new Date();
      timeDate.setHours(+timeParts[0]);
      timeDate.setMinutes(+timeParts[1]);
      timeDate.setSeconds(+timeParts[2]);

      // Format the time to 12-hour format with AM/PM
      const formattedTime = this.formatTimeAMPM(timeDate);
      this.form.patchValue({
        PreferredTime: formattedTime
      });
    } else {
      console.log("No last_slot_datetime provided.");
    }
  }

  // Helper function to format time with AM/PM
  formatTimeAMPM(date: Date): string {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutesStr = minutes < 10 ? '0' + minutes : minutes.toString();
    const strTime = hours + ':' + minutesStr + ' ' + ampm;
    return strTime;
  }

  isCustomMessageVisible(): boolean {
    return this.preSelectedStatuses.includes(this.props.item.status);
  }

  getConditionalValidators() {
    return (control: AbstractControl) => {
      if (
        this.form.get('custom_message')?.value &&
        this.form.get('NotifyUsers')?.value
      ) {
        return Validators.required(control);
      } else {
        return null; // If custom_message is unchecked, disable the validation.
      }
    };
  }

  onDateChange(event: any, controlName: string) {
    const formattedDate = moment(event.value).format('YYYY-MM-DD');
    if (controlName === 'patientDob') {
    } else if (controlName === 'appointmentDate') {
      this.form.get('appointment_datetime')?.setValue(formattedDate);
    }
  }

  get notifyByArray() {
    return this.form.get('NotifyUsersBy') as FormArray;
  }
  private addNotifyControl() {
    this.form.addControl(
      'NotifyUsersBy',
      this.fb.array([], arrayMinLengthByKey(1, 'isChecked'))
    );
    NotifySlUsersBy.forEach((x: any) => {
      this.notifyByArray.push(
        this.fb.group({
          id: new FormControl(x.id),
          value: new FormControl(x.value),
          isChecked: new FormControl(x.isChecked),
          disable: new FormControl(false),
        })
      );
    });
  }

  getAppointmentBasicData() {
    const paylaod = {};
    this.appointmentService.getAppointmentBasicData(paylaod).subscribe(
      (res: any) => {
        if (res.body.success) {
          this.appointmentsPlateform = res.body.data.appointments_plateform;
          this.patientGroupList = res.body.data.patient_group;
          this.userAppointmentMessage =
            res.body.data.user_appointment_message.message.en;
        } else {
          this.toastr.error(res.body.message);
        }
      },
      (err) => {
        this.toastr.error(err.message);
      }
    );
  }

  openAddAppointementModal() {
    const dialogRef = this.dialog.open(AddAppointmentPlatformComponent, {
      disableClose: true,
      width: '650px',
      data: { location: this.formService.selectedLocation.value },
    });
    dialogRef.afterClosed().subscribe((result) => {
      // this.getNursingHome();
      this.getAppointmentBasicData();
    });
  }

  openAddPatientGroupModal() {
    const dialogRef = this.dialog.open(AddPatientGroupModalComponent, {
      disableClose: true,
      width: '650px',
      data: { location: this.formService.selectedLocation.value },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getAppointmentBasicData();
    });
  }

  // Custom validator to check if the date is in the past
  validateFutureDate(control: AbstractControl) {
    const dateValue = control.value;
    if (dateValue && moment(dateValue).isBefore(moment(), 'day')) {
      return { pastDate: true };
    }
    return null;
  }


  getCurrentDate(): string {
    if (!this.currentDate) {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = ('0' + (currentDate.getMonth() + 1)).slice(-2);
      const day = ('0' + currentDate.getDate()).slice(-2);
      this.currentDate = `${year}-${month}-${day}`;
    }

    return this.currentDate;
  }

  private formatAppointmentDateTime(date: string, time: string): string {
    if (!date) {
      return "";
    }
    const dateTimeString = `${date}, ${time}`;
    const formattedDateTime = moment(dateTimeString, 'YYYY-MM-DD, hh:mm A').format('YYYY-MM-DD, hh:mm A');
    return formattedDateTime;
  }

  formSubmit() {
    if (this.form.valid) {
      const appointmentDateTime = this.formatAppointmentDateTime(
        this.form.value.appointment_datetime,
        this.form.value.PreferredTime
      );
      let payload: {
        id: any;
        practitioner_name: any;
        appointment_datetime: any;
        user_id: string;
        status: string;
        type: string;
        appointment_platform_id: string;
        patient_group_id: string;
        appointment_video_link: string;
        CustomMessage: boolean;
        Message?: string;
        NotifyUsers: boolean;
        NotifyUsersBy: any;
      } = {
        id: this.props.item.id,
        practitioner_name: this.form.value.practitioner_name,
        appointment_datetime: appointmentDateTime,
        user_id: this.props.item.user_id,
        status: this.props.item.status,
        type: this.props.item.status,
        appointment_platform_id: this.form.value.appointment_platform_id,
        patient_group_id: this.form.value.patient_group_id,
        appointment_video_link: encodeURIComponent(this.form.value.appointment_video_link),
        CustomMessage: this.form.value.custom_message,
        Message: this.form.value.custom_message ? this.form.value.message : '',
        NotifyUsers: this.form.value.NotifyUsers,
        // NotifyUsersBy: this.form.value.NotifyUsersBy,
        NotifyUsersBy:
          this.form.value.NotifyUsersBy?.length > 0
            ? this.form.value.NotifyUsersBy.filter((f: any) => f.isChecked).map(
              (m: any) => m.id
            )
            : [],
      };
      this.isLoading = true;
      this.appointmentService.updateStatus(payload).subscribe(
        (res) => {
          if (res.body.success) {
            this.toast.success(res.body.message);
            this.dialogRef.close({ payload: payload, response: res.body });
            this.isLoading = false;
          } else {
            this.toast.error(res.body.message);
            this.isLoading = false;
          }
        },
        (err) => {
          console.error("Error occurred:", err);
          this.isLoading = false;
          this.toast.error('An error occurred while updating delivery status.');
        }
      );
    } else {
      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.get(key);
        if (control?.invalid) {
          console.error(key + ':', control.value);

          // Check for appointment_datetime error
          if (key == 'appointment_datetime') {
            this.toast.error('Please enter a valid appointment date.');
          }
        }
      });
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }

}
